import React from 'react';
import { useAppSelector } from '../hooks';
import App from '../app';

const AppContainer = () => {
  const { jwt, me, error } = useAppSelector(state => state.auth);

  // If not authenticated yet or in error state, render App without Header
  if (!jwt || !me || error) {
    return <App />;
  }

  // App is decommissioned - always show access denied message
  return <App />;
};

export default AppContainer;
